// React import
import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
// Actions import
import {
    setAiCheckWalletError,
    setAiCheckWalletProcessing,
    setCheckWalletStats,
    setAiNewText,
    unsetAiNewText,
    setCheckWalletProcessingStats,
    showNotification,
    hideNotification,
    changeUserData
} from "../../actions";
// Import hooks
import {apiRequests} from "../../hooks/apiRequests";
// Styles imports
import './WalletSearch.css';
import '../../util.css'
// Import Svg icons
import { ReactComponent as SearchStatusSvg } from '../../svg-icons/search-status.svg';
import { ReactComponent as ArrowRightSvg } from '../../svg-icons/arrow-right.svg';
// Import consts
import {
    BASE, BSC,
    CHECK_WALLET_PAUSES,
    CHECK_WALLET_PAUSES_TRY_NUMBER,
    ETH,
    RESULT
} from "../../consts/consts";

function isValidEthereumAddress(address) {
    const ethAddressRegex = /^0x[a-fA-F0-9]{40}$/;
    return ethAddressRegex.test(address);
}

class WalletSearch extends React.Component {

    constructor(props) {
        super(props);
        this.state = {inputData: ""};
    }

    setNotification = (message, duration = 750) => {
        const { showNotification, hideNotification } = this.props;
        showNotification({message: message, duration: duration});
        setTimeout(() => {
            hideNotification();
        }, duration);
    }

    keyDown = async (event) => {
        const { parseCheckWalletResult, reqCheckWalletOrSetTask } = apiRequests();
        const { setCheckWalletStats, setAiCheckWalletProcessing,setAiNewText,
            setCheckWalletProcessingStats, changeUserData } = this.props;
        const { blockchain } = this.props.blockchain;
        const { id, token, num_of_check_wallet_req, ai_energy } = this.props.userData;

        const { status } = this.props.checkWallet;

        const wait = t => new Promise(s => setTimeout(s, t));

        if (event.key === "Enter") {

            if (num_of_check_wallet_req <= 0 && ai_energy < 100) {
                this.setNotification("Not enough AI energy", 1500);
                return null;
            }
            if (num_of_check_wallet_req <= 0){
                this.setNotification("Check Wallet request limit exceeded", 1500);
                return null;
            }
            if (ai_energy < 100) {
                this.setNotification("Not enough AI energy", 1500);
                return null;
            }

            if ((blockchain === ETH || blockchain === BASE || blockchain === BSC) && isValidEthereumAddress(this.state.inputData)) {
                ///////////////
                try {
                    event.target.blur();
                    let response = await reqCheckWalletOrSetTask(id, token, blockchain, this.state.inputData);
                    if ('user_info' in response) {
                        changeUserData(response['user_info']);
                    }
                    if(response['status'] === "RESULT") {
                        if ('user_info' in response) {
                            changeUserData(response['user_info']);
                        }
                        setCheckWalletStats(parseCheckWalletResult(response['data']));
                    } else if (response['status'] === "PROCESSING") {
                        let task = response['task'];
                        if ('user_info' in response) {
                            changeUserData(response['user_info']);
                        }
                        for (let i = 0; i < CHECK_WALLET_PAUSES_TRY_NUMBER; i++) {
                            setAiCheckWalletProcessing();
                            setAiNewText();
                            setCheckWalletProcessingStats();
                            await wait(CHECK_WALLET_PAUSES[i]);
                            let response = await reqCheckWalletOrSetTask(id, token, blockchain, this.state.inputData, task);
                            if(response['status'] === "RESULT") {
                                setCheckWalletStats(parseCheckWalletResult(response['data']));
                                if ('user_info' in response) {
                                    changeUserData(response['user_info']);
                                }
                                break;
                            }
                            if(response['status'] === "ERROR") {
                                this.setNotification("Request error. Attempt " + (i+1) +"/"+CHECK_WALLET_PAUSES_TRY_NUMBER, 2500);
                                if ((i+1) === CHECK_WALLET_PAUSES_TRY_NUMBER) {
                                    this.setNotification("Request error.\nTry again later.", 2500);
                                    break;
                                }
                            }
                            if ((i+1) === CHECK_WALLET_PAUSES_TRY_NUMBER) {
                                this.setNotification("Number of attempts expired.", 1500);
                            }
                        }
                    } else if (response['status'] === "ERROR") {
                        if ('user_info' in response) {
                            changeUserData(response['user_info']);
                        }

                        if(response['code'] === 410) {
                            this.setNotification("Not enough AI energy", 1500);
                        } else if (response['code'] === 411) {
                            this.setNotification("Check Wallet request limit exceeded", 1500);
                        } else if (response['code'] === 404) {
                            this.setNotification("There is no connection with the AI", 1500);
                        } else if (response['code'] === 403) {
                            this.setNotification("Invalid username/token", 1500);
                        } else if (response['code'] === 500) {
                            this.setNotification("Internal Server Error", 1500);
                        } else {
                            this.setNotification("Unknown error", 1500);
                        }
                    }
                } catch (error) {
                    this.setNotification("Unknown error. Try again.", 1500);
                }
                /////////////
            } else {
                this.setNotification("Invalid wallet address.", 1500);
            }


        }
    };

    handleChange = (event) => {
        this.setState({inputData: event.target.value});
    }

    handleClick = async () => {

        const { parseCheckWalletResult, reqCheckWalletOrSetTask } = apiRequests();
        const { setCheckWalletStats, setAiCheckWalletProcessing,setAiNewText,
            setCheckWalletProcessingStats, changeUserData } = this.props;
        const { blockchain } = this.props.blockchain;
        const { id, token, num_of_check_wallet_req, ai_energy } = this.props.userData;

        const { status } = this.props.checkWallet;

        const wait = t => new Promise(s => setTimeout(s, t));

        if (num_of_check_wallet_req <= 0 && ai_energy < 100) {
            this.setNotification("Not enough AI energy", 1500);
            return null;
        }
        if (num_of_check_wallet_req <= 0){
            this.setNotification("Check Wallet request limit exceeded", 1500);
            return null;
        }
        if (ai_energy < 100) {
            this.setNotification("Not enough AI energy", 1500);
            return null;
        }

        if ((blockchain === ETH || blockchain === BASE || blockchain === BSC) && isValidEthereumAddress(this.state.inputData)) {
            ///////////////
            try {
                event.target.blur();
                let response = await reqCheckWalletOrSetTask(id, token, blockchain, this.state.inputData);

                if ('user_info' in response) {
                    changeUserData(response['user_info']);
                }
                if(response['status'] === "RESULT") {
                    if ('user_info' in response) {
                        changeUserData(response['user_info']);
                    }
                    setCheckWalletStats(parseCheckWalletResult(response['data']));
                } else if (response['status'] === "PROCESSING") {
                    let task = response['task'];
                    if ('user_info' in response) {
                        changeUserData(response['user_info']);
                    }
                    for (let i = 0; i < CHECK_WALLET_PAUSES_TRY_NUMBER; i++) {
                        setAiCheckWalletProcessing();
                        setAiNewText();
                        setCheckWalletProcessingStats();
                        await wait(CHECK_WALLET_PAUSES[i]);
                        let response = await reqCheckWalletOrSetTask(id, token, blockchain, this.state.inputData, task);
                        if(response['status'] === "RESULT") {
                            setCheckWalletStats(parseCheckWalletResult(response['data']));
                            if ('user_info' in response) {
                                changeUserData(response['user_info']);
                            }
                            break;
                        }
                        if(response['status'] === "ERROR") {
                            this.setNotification("Request error. Attempt " + (i+1) +"/"+CHECK_WALLET_PAUSES_TRY_NUMBER, 2500);
                            if ((i+1) === CHECK_WALLET_PAUSES_TRY_NUMBER) {
                                this.setNotification("Request error.\nTry again later.", 2500);
                                break;
                            }
                        }
                        if ((i+1) === CHECK_WALLET_PAUSES_TRY_NUMBER) {
                            this.setNotification("Number of attempts expired.", 1500);
                        }
                    }
                } else if (response['status'] === "ERROR") {
                    if ('user_info' in response) {
                        changeUserData(response['user_info']);
                    }

                    if(response['code'] === 410) {
                        this.setNotification("Not enough AI energy", 1500);
                    } else if (response['code'] === 411) {
                        this.setNotification("Check Wallet request limit exceeded", 1500);
                    } else if (response['code'] === 404) {
                        this.setNotification("There is no connection with the AI", 1500);
                    } else if (response['code'] === 403) {
                        this.setNotification("Invalid username/token", 1500);
                    } else if (response['code'] === 500) {
                        this.setNotification("Internal Server Error", 1500);
                    } else {
                        this.setNotification("Unknown error", 1500);
                    }
                }
            } catch (error) {
                this.setNotification("Unknown error. Try again.", 1500);
            }
            /////////////
        } else {
            this.setNotification("Invalid wallet address.", 1500);
        }


    };

    render () {



        return (
            <div className={"check-wallet__search"}>
                <SearchStatusSvg className={"check-wallet__search-icon"}/>
                <input type={"search"} className={"check-wallet__search-input"} onKeyDown = {this.keyDown} onChange={this.handleChange}/>
                <div className={"search-block"} onClick={this.handleClick}>
                    <ArrowRightSvg className={"check-wallet__arrow-right-icon"}/>
                </div>

            </div>
        );
    }

}

const mapStateToProps = ({ checkWallet, blockchain, userData }) => {
    return { checkWallet, blockchain, userData };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setCheckWalletStats: setCheckWalletStats,
        setAiCheckWalletProcessing: setAiCheckWalletProcessing,
        setAiCheckWalletError: setAiCheckWalletError,
        setAiNewText: setAiNewText,
        unsetAiNewText: unsetAiNewText,
        setCheckWalletProcessingStats: setCheckWalletProcessingStats,
        showNotification: showNotification,
        hideNotification: hideNotification,
        changeUserData: changeUserData
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(WalletSearch);